<template>
<div class="login-page" >
  <div id="Login" class="Login">
    <van-icon name="close" class="icon-close" @click="$parent.handleLogin(false)" />
    <van-cell-group>
      <van-field
        v-model="username"
        label="用户名"
        placeholder="请输入用户名"
        required
      />

      <van-field
        v-model="password"
        type="password"
        label="密码"
        placeholder="请输入密码"
        required
      />
    </van-cell-group>
    <van-button class="btn" size="large" type="primary" @click="login" >登入</van-button>
  </div>
</div>
  
</template>

<script>
  import {Toast} from 'vant'
  import http from '../config/axios.js'
  import md5 from 'js-md5'
  export default {
    name: "Login",
    data() {
      return {
        username:'',
        password:''
      }
    },
    mounted() {
    },
    methods: {
      login(){
        if(this.username && this.password){
          http.post('user/panoUserLogin.do',{username:this.username,password:md5(this.password)}).then(res=>{
            if(res.code == '000000'){
              window.localStorage.setItem('token',JSON.stringify(res.data.token))
              window.localStorage.setItem('user',JSON.stringify(res.data))
              window.location.href = window.location.href;
            }
          })
        } else{
          Toast('账号或者密码不能为空')
        }
        
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped >
    .login-page{
      z-index:999;
    }
    .Login{
      position: fixed;
      z-index:101;
      top:50%;
      left:50%;
      transform:translate(-50%,-50%);
      width:260px;
      padding:20px 10px;
      padding-top:35px;
      background-color:#fff;
      border:1px #eee solid;
      // box-shadow: 0 0 2px 2px #eee;
      border-radius:5px;
      .btn{
        margin-top:10px;
      }
      .icon-close{
        position:absolute;
        z-index: 1;
        top:0;
        right:0;
        padding:5px;
        color:#000;
        cursor: pointer;
      }
    }
</style>



// WEBPACK FOOTER //
// src/components/Login.vue